<template lang="pug">
    section#empregabilidade.conteudoEgressos
        div.wrapper(v-if="conteudo != null", :class="{noflex: conteudo.has_titulo}")
            hr.hrDesenvolvimento
            h2(v-if="conteudo.has_titulo") {{ conteudo.titulo }}
            div(v-html="conteudo.conteudo").conteudo
</template>

<script>
export default {
    name: "section-empregabilidade",
    props:{
        conteudo: Object,
    }
}
</script>

<style lang="stylus" scoped src="./Empregabilidade.styl"></style>